// extracted by mini-css-extract-plugin
module.exports =  {"root":"IntervalSelector-module__root--qBVY_","trigger":"IntervalSelector-module__trigger--K2xst"};